import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { TokenService } from '../services/token.service';

const LOGIN_PATH = '/login';

/**
 * Agrega `Authorization: Bearer <token>` a las peticiones hacia URL_API
 * (excepto el login) y cierra sesión si el backend responde 401.
 */
export const adminApiInterceptor: HttpInterceptorFn = (req, next) => {
  const isAdminApi = req.url.startsWith(environment.URL_API);
  if (!isAdminApi) {
    return next(req);
  }

  const isLogin = req.url.startsWith(`${environment.URL_API}${LOGIN_PATH}`);
  if (isLogin) {
    return next(req);
  }

  const tokenService = inject(TokenService);
  // AuthenticationService depende de HttpClient: se resuelve de forma diferida
  // para no crear una dependencia circular con este interceptor.
  const injector = inject(Injector);

  const token = tokenService.get();
  const authReq =
    token && !req.headers.has('Authorization')
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

  return next(authReq).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        injector.get(AuthenticationService).logout();
      }
      return throwError(() => error);
    })
  );
};
